var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ar-text',{staticClass:"heading",attrs:{"size":_vm.size,"text":_vm.title,"weight":_vm.weight,"align":_vm.align,"multiple-lines":_vm.multipleLines}})}
var staticRenderFns = []

export { render, staticRenderFns }